<template>
    <div class="content">
      <div class="col-md-8 flex-container-top">
        <base-button type="primary" round icon class="top-button-back" @click="$router.push('list')">
          <i class="fa fa-arrow-left"></i>
        </base-button>
  
        <h2 v-if="!isEdit" class="text-center">Add Group</h2>
        <h2 v-if="isEdit" class="text-center">Edit Group</h2>
      </div>
      <div class="row">
        <div class="col-md-8">
          <card>
            <form onSubmit="return false;">
              <div class="row">
                <div class="col-md-12">
                  <base-input type="text" label="Group Name *" maxlength="50" placeholder="Name" v-model="group_name">
                  </base-input>
                </div>
              </div>
  
              <div class="row mt-4">
                <div class="col-md-12">
                  <base-input label="Link *">
                    <textarea maxlength="250" class="form-control" placeholder="Link" v-model="link"></textarea>
                  </base-input>
                </div>
              </div>
              <hr>

              <base-button v-if="!isEdit" native-type="submit" type="primary" @click="AddGroup()" 
                class="btn-fill" :disabled="loading">Save
              </base-button>
  
              <base-button v-if="isEdit" native-type="submit" type="primary" @click="UpdateGroup()"
                class="btn-fill" :disabled="loading">Update
              </base-button>

            </form>
          </card>
        </div>
        <div class="col-md-4" v-for="user in [1]" v-bind:key="user">
          <card class="card-user">
            <p class="card-text"></p>
            <div class="author">
              <div class="block block-one"></div>
              <div class="block block-two"></div>
              <div class="block block-three"></div>
              <div class="block block-four"></div>
              <div class="col-md-12 col-sm-12" v-if="!isEdit">
                <h4 class="card-title">Image</h4>
                <image-upload :src="image" @change="onImageChange" select-text="Select Image" />
              </div>
              <div class="col-md-12 col-sm-12" v-if="isEdit">
                <h4 class="card-title">Group Image *</h4>
                <image-upload :src="image" @change="onImageChange" select-text="Update Image" />
              </div>
            </div>
          </card>
        </div>
      </div>
  
      <div class="full-screen-loader" v-if="loading">
        <div class="sk-chase">
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
        </div>
      </div>
    </div>
  </template>

<script>

import { ImageUpload } from "src/components/index";
import { stripVTControlCharacters } from "util";
import { image } from "vee-validate/dist/rules";

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      link: "",
      group_name: "",
      image: null,
      isEdit: false,
      loading: false,
      imageUploaded: false,
    };
  },

  async mounted() {

    let id = this.$route.query.id;
    if (id == -1) {
      this.isEdit = false;
    } else {
      // value = "Compare";
      this.isEdit = true;
      let eve = await this.$apiService.getCall("joingroup/get-groupbyid/" + id);
      console.log('apidata', eve);
      this.group_name = eve.apidata.Data.group_name;
      this.image = eve.apidata.Data.image;
      this.link = eve.apidata.Data.link;
    }

    var _self = this;

    var input = document.getElementById("auto-complete-text");
    
  },

  methods: {
    async UpdateGroup() {

      var id = this.$route.query.id;
      if (
        !this.group_name &&
        !this.link &&
        !this.image 
      ) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.group_name) {
        this.$apiService.notify("Group Name is mandatory.");
        return;
      }
      
      if (!this.link) {
        this.$apiService.notify("Link are mandatory.");
        return;
      }

      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      let imagelink = this.image;
      if (this.imageUploaded) {
        imagelink = await this.$apiService.uploadImage(this.image);
      }

      var Evedata = {
        group_name: this.group_name,
        image: imagelink,
        link: this.link,
      };

      var update_eve = await this.$apiService.postCall(
        "joingroup/update-group/" + id,
        Evedata
      );

      this.$apiService.notify("Group has been updated.");
      this.$router.push("/whatsappgroup/list");
    },

    async AddGroup() {
      if (
        !this.group_name &&
        !this.link &&
        !this.image 
      ) {
        this.$apiService.notify("All fields are mandatory.");
        return;
      }
      if (!this.group_name) {
        this.$apiService.notify("Group Name is mandatory.");
        return;
      }
     
      if (!this.link) {
        this.$apiService.notify("Link are mandatory.");
        return;
      }

      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }
      this.loading = true;

      const imagelink = await this.$apiService.uploadImage(this.image);

      await this.$apiService.postCall("joingroup/add-group/", {
        group_name: this.group_name,
        link: this.link,
        image: imagelink,
      });
      this.$apiService.notify("Group has been added.", { duration: 2000 });
      this.loading = false;
      this.$router.push("/whatsappgroup/list");
    },
    onImageChange(file) {
      this.image = file;
      this.imageUploaded = true;
    },
  }
};
</script>